<template>
  <div class="img-bg">
    <br />
    <!-- <pre>{{ parseFloat(get_data.ROData.water_consumption.flowtoday) }}</pre>
    <pre>{{ parseFloat(get_data.REData.water_consumption.flowtoday) }}</pre> -->
    <!-- <pre>{{ get_data.REData }}</pre> -->
    <vs-row vs-w="12">
      <vs-col vs-type="flex" vs-justify="center" vs-lg="7" vs-sm="12" vs-xs="12">
        <vs-card class="cardborder d-flex align-items-center">
          <div style="position: relative">
            <img align="center" style="width: 100%; display: block"
              src="../../../../assets/images/gif Yamaha/mapyamahaaddlogo.png" />

            <div v-for="i in iconvalue" :key="i">
              <b-tooltip :target="i.class">
                <h6 class="mb-2">{{ i.name }}</h6>
                <img style="height: 100%; width: 100%; cursor: pointer" :src="i.src" @click="goTo(i.path)" />
              </b-tooltip>
              <vs-icon @click="goTo(i.path)" :id="i.class" size="10px" style="cursor: pointer; pointer-events: auto"
                :class="i.class" icon="fiber_manual_record"></vs-icon>
            </div>
          </div>
        </vs-card>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-lg="5" vs-sm="12" vs-xs="12">
        <vs-row>
          <vs-row class="mb-3">
            <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
              <div class="d-flex justify-content-center cardbox">
                <img class="mt-1 mb-1" align="center" width="230" v-if="username == 'yamahademo'"
                  src="../../../../assets/images/gif Yamaha/logo.png" />
              </div>
            </vs-col>
          </vs-row>
          <vs-row class="mb-3">
            <vs-col vs-type="flex" vs-justify="center" vs-lg="6" vs-sm="12" vs-xs="12">
              <div style="padding: 0" class="cardbox container">
                <h4 class="mt-2 wheader" align="center">
                  Daily Wastewater Treated
                </h4>
                <vs-row>
                  <vs-col style="padding: 0" vs-type="flex" vs-align="center" vs-w="5">
                    <img height="127" style="border-bottom-left-radius: 20px; width: 100%"
                      src="../../../../assets/images/gif Yamaha/waterfall.gif" alt="" />
                  </vs-col>
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="7">
                    <ul class="listnone mt-2" align="center">
                      <li>
                        <h1 class="wvalue">
                          {{
                            parseFloat(
                              get_data.ASData.ASWaterDailyVolume
                            ).toFixed(2)
                          }}
                        </h1>
                      </li>
                      <li class="mt-2">
                        <h4>
                          <b>m<sup>3</sup></b>
                        </h4>
                      </li>
                    </ul>
                  </vs-col>
                </vs-row>
              </div>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-lg="6" vs-sm="12" vs-xs="12">
              <div style="padding: 0" class="cardbox container">
                <h4 class="mt-2 wheader" align="center">
                  Daily Power Consumption
                </h4>
                <vs-row>
                  <vs-col style="padding: 0" vs-type="flex" vs-align="center" vs-w="5">
                    <img width="80" src="../../../../assets/images/gif Yamaha/fan.gif" alt="" />
                  </vs-col>
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="7">
                    <ul class="listnone mt-2" align="center">
                      <li>
                        <h1 class="wvalue">
                          {{
                            parseFloat(
                              get_data.ASData.power_consumption.total
                            ).toFixed(2)
                          }}
                        </h1>
                      </li>
                      <li class="mt-2">
                        <h4>
                          <b>kWh</b>
                        </h4>
                      </li>
                    </ul>
                  </vs-col>
                </vs-row>
              </div>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col vs-type="flex" vs-justify="center" vs-lg="6" vs-sm="12" vs-xs="12">
              <vs-card class="cardborder">
                <h4 class="mt-2 wheader" align="center">
                  Total Recycle Waste Treated
                </h4>
                <ul class="listnone mt-3" align="center">
                  <li>
                    <h1 class="wvalue mb-1">
                      <b>{{
                        (
                          parseFloat(
                            get_data.ROData.water_consumption.flowtoday
                          ) +
                          parseFloat(
                            get_data.REData.water_consumption.flowtoday
                          )
                        ).toFixed(2)
                      }}</b>
                    </h1>
                  </li>
                  <li>
                    <h4>
                      <b>m<sup>3</sup></b>
                    </h4>
                  </li>
                </ul>
              </vs-card>
            </vs-col>
            <vs-col vs-lg="6" vs-sm="12" vs-xs="12">
              <div>
                <vs-card class="cardborder">
                  <h4 class="wsheader mb-2" align="center">Recycle Water</h4>
                  <h3 align="center">
                    <b>{{
                      parseFloat(
                        get_data.REData.water_consumption.flowtoday
                      ).toFixed(2)
                    }}</b>
                    m<sup>3</sup>
                  </h3>
                </vs-card>
                <vs-card class="cardborder">
                  <h4 class="wsheader mb-2" align="center">RO Recycle Water</h4>
                  <h3 align="center">
                    <b>{{
                      parseFloat(
                        get_data.ROData.water_consumption.flowtoday
                      ).toFixed(2)
                    }}</b>
                    m<sup>3</sup>
                  </h3>
                </vs-card>
              </div>
            </vs-col>
          </vs-row>
        </vs-row>
      </vs-col>
    </vs-row>
    <vs-row vs-w="12">
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
        <vs-card class="cardborder">
          <vs-row>
            <h4 class="wheader">Wastewater Consumption Graph</h4>
            <vs-spacer />
            <vs-select class="selectExample" @change="fillData(select_option)" v-model="select_option">
              <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in options_graph" />
            </vs-select>
            <div class="mt-3" style="position: relative; width: 100%">
              <barchart :chartData="datacollection" :options="option" :height="270"></barchart>
            </div>
            <!-- <div style="position: relative; width: 100%">
              <div>
                <canvas id="planet-chart"></canvas>
              </div>
            </div> -->
          </vs-row>
        </vs-card>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import Chart from "chart.js";
import planetChartData from "./chart/planet-data.js";
import barchart from "./chart/barchart/Chart.js";
// import PlanetChart from "./chart/PlanetChart.vue";
export default {
  components: {
    // PlanetChart,
    barchart,
  },
  data: () => ({
    planetChartData: planetChartData,
    options_graph: [
      { text: "Daily", value: 1 },
      { text: "Weekly", value: 2 },
      { text: "Monthly", value: 3 },
      { text: "Yearly", value: 4 },
    ],
    select_option: 1,
    iconvalue: [
      {
        name: "Plastic Painting WWTP",
        class: "icon1",
        path: "PlasticPaintingWWTPplant",
        src: require("../../../../assets/images/gif Yamaha/Plastic.jpg"),
      },
      {
        name: "Aluminium Painting WWTP",
        class: "icon2",
        path: "AluminiumPaintingWWTPplant",
        src: require("../../../../assets/images/gif Yamaha/Aluminium.jpg"),
      },
      {
        name: "Center Plant",
        class: "icon3",
        path: "centerplant",
        src: require("../../../../assets/images/gif Yamaha/CENTER.jpg"),
      },
      {
        name: "DAF Plant",
        class: "icon4",
        path: "dafplant",
        src: require("../../../../assets/images/gif Yamaha/DAF.jpg"),
      },
      {
        name: "RO Plant",
        class: "icon5",
        path: "roplant",
        src: require("../../../../assets/images/gif Yamaha/RO recycle.jpg"),
      },
      {
        name: "AS Plant",
        class: "icon6",
        path: "asplant",
        src: require("../../../../assets/images/gif Yamaha/BIOAS.jpg"),
      },
      {
        name: "MBR Plant",
        class: "icon7",
        path: "mbrplant",
        src: require("../../../../assets/images/gif Yamaha/MBR.jpg"),
      },
      {
        name: "Recycle Plant",
        class: "icon8",
        path: "recycleplant",
        src: require("../../../../assets/images/gif Yamaha/recycle.jpg"),
      },
    ],
    datacollection: [],
    options: [],
    datacollection: null,
    option: null,
    get_data: [],
    interval: null,
    username: "",
  }),
  methods: {
    goTo(item) {
      this.$router.push(item);
    },
    selectWater(item) { },
    selectph3() {
      this.datacollection = {
        labels: ["January", "February"],
        datasets: [
          {
            data: [40, 20],
            backgroundColor: "rgba(71, 183,132,.5)",
            borderColor: "#47b784",
            borderWidth: 3,
          },
        ],
      };
      this.option = {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          display: false,
        },
        scales: {
          yAxes: [
            {
              id: "A",
              ticks: {
                beginAtZero: true,
              },
              position: "left",
              scaleLabel: {
                display: true,
                labelString: "pH Value (pH)",
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              scaleLabel: {
                display: true,
                labelString: "Timestamp",
              },
            },
          ],
        },
      };
    },
    async fillData(item) {
      var label = [];
      var data1 = [];
      var data_ro = [];
      var plus = [];
      var avg = [];
      var data_re = [];
      if (item === 1) {
        console.log("Daily");
        this.get_data.REData.water_daily.forEach((i) => {
          label.push(i.time);
          data_re.push(i.water);
        });
        this.get_data.ROData.water_daily.forEach((i) => {
          data_ro.push(i.water);
        });
        plus = data_re.map((i) =>
          (i = parseFloat(i) + parseFloat(data_ro)).toFixed(2)
        );

        avg = data_re.map(
          (i) =>
          (i = (
            (parseFloat(i) / (parseFloat(i) + parseFloat(data_ro))) *
            100
          ).toFixed(2))
        );

        console.log(plus);
      } else if (item === 2) {
        console.log("Weekly");
        this.get_data.REData.water_weekly.forEach((i) => {
          label.push(i.time);
          data_re.push(i.water);
        });
        this.get_data.ROData.water_weekly.forEach((i) => {
          data_ro.push(i.water);
        });
        plus = data_re.map((i) =>
          (i = parseFloat(i) + parseFloat(data_ro)).toFixed(2)
        );

        avg = data_re.map(
          (i) =>
          (i = (
            (parseFloat(i) / (parseFloat(i) + parseFloat(data_ro))) *
            100
          ).toFixed(2))
        );

        console.log(plus);
      } else if (item === 3) {
        console.log("monthly");
        this.get_data.REData.water_monthly.forEach((i) => {
          label.push(i.time);
          data_re.push(i.water);
        });
        this.get_data.ROData.water_monthly.forEach((i) => {
          data_ro.push(i.water);
        });
        plus = data_re.map((i) =>
          (i = parseFloat(i) + parseFloat(data_ro)).toFixed(2)
        );

        avg = data_re.map(
          (i) =>
          (i = (
            (parseFloat(i) / (parseFloat(i) + parseFloat(data_ro))) *
            100
          ).toFixed(2))
        );
      } else if (item === 4) {
        console.log("Yearly");
        this.get_data.REData.water_yearly.forEach((i) => {
          label.push(i.time);
          data_re.push(i.water);
        });
        this.get_data.ROData.water_yearly.forEach((i) => {
          data_ro.push(i.water);
        });
        plus = data_re.map((i) =>
          (i = parseFloat(i) + parseFloat(data_ro)).toFixed(2)
        );

        avg = data_re.map(
          (i) =>
          (i = (
            (parseFloat(i) / (parseFloat(i) + parseFloat(data_ro))) *
            100
          ).toFixed(2))
        );
      }
      this.datacollection = {
        labels: label.reverse(),
        datasets: [
          {
            label: "Total Wastewater Treated/Total Recycle Waste Wreated",
            type: "line",
            data: avg.reverse(),
            backgroundColor: "rgba(255, 255,255,.0)",
            borderColor: "#32c040",
            borderWidth: 2,
            yAxisID: "B",
          },
          {
            type: "bar",
            backgroundColor: "#3498DB ",
            borderColor: "#3498DB ",
            borderWidth: 3,
            label: "Total Wastewater Treated",
            data: plus.reverse(),
            yAxisID: "A",
          },
          {
            label: "Total Recycle Waste Treated",
            type: "bar",
            data: data_re.reverse(),
            backgroundColor: "#0A363E",
            borderColor: "#0A363E",
            borderWidth: 3,
            yAxisID: "A",
          },
        ],
      };
      this.option = {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          display: true,
          position: "bottom",
        },
        scales: {
          yAxes: [
            {
              id: "A",
              ticks: {
                beginAtZero: true,
                steps: 5,
                stepValue: 5,
              },
              position: "left",
              scaleLabel: {
                display: true,
                labelString: "m3",
              },
            },
            {
              id: "B",
              ticks: {
                beginAtZero: true,
                steps: 5,
                stepValue: 5,
                max: 100,
              },
              position: "right",
              scaleLabel: {
                display: true,
                labelString: "%",
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              //   scaleLabel: {
              //     display: true,
              //     labelString: "Timestamp",
              //   },
            },
          ],
        },
      };
    },
    async calldata() {
      var api_data = [];
      api_data = await this.$API.get(`yamaha/map`);
      this.get_data = api_data.data;
      await this.fillData(this.select_option);

      this.interval = setTimeout(async () => {
        this.calldata();
      }, 60 * 1000);
    },
  },
  async mounted() {
    this.$vs.loading();
    this.username = this.$session.get("username");
    var api_data = [];
    api_data = await this.$API.get(`yamaha/map`);
    this.get_data = api_data.data;
    this.$vs.loading.close();
    await this.fillData(this.select_option);

    this.interval = setTimeout(async () => {
      this.calldata();
    }, 60 * 1000);
  },
  beforeDestroy() {
    clearTimeout(this.interval);
  },
};
</script>

<style scoped>
.img-bg {
  padding: 0;
  background-image: url("../../../../assets/images/gif Yamaha/map_over.png");
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
}

.icon1 {
  position: absolute;
  color: rgba(255, 255, 255, 0);
  top: 6%;
  left: 52.5%;
}

.icon2 {
  position: absolute;
  color: rgba(255, 255, 255, 0);
  top: 12.7%;
  left: 18.5%;
}

.icon3 {
  position: absolute;
  color: rgba(255, 255, 255, 0);
  bottom: 17%;
  left: 31%;
}

.icon4 {
  position: absolute;
  color: rgba(255, 255, 255, 0);
  bottom: 17%;
  left: 46%;
}

.icon5 {
  position: absolute;
  color: rgba(255, 255, 255, 0);
  bottom: 23%;
  left: 43%;
}

.icon6 {
  position: absolute;
  color: rgba(255, 255, 255, 0);
  bottom: 29.7%;
  left: 40.6%;
}

.icon7 {
  position: absolute;
  color: rgba(255, 255, 255, 0);
  bottom: 36%;
  left: 37.8%;
}

.icon8 {
  position: absolute;
  color: rgba(255, 255, 255, 0);
  bottom: 42%;
  left: 34.6%;
}

.cardbox {
  background-color: rgba(255, 255, 255, 0.75);
  border-radius: 20px;
  display: block;
  -webkit-box-shadow: 0 4px 25px 0 rgb(0 0 0 / 10%);
  box-shadow: 0 4px 25px 0 rgb(0 0 0 / 10%);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}

.cardborder {
  border-radius: 20px;
  background-color: rgba(255, 255, 255, 0.75);
}

.wheader {
  font-weight: 600;
  font-size: 1.3vw;
  color: #343a40;
  /* color: red; */
}

.wsheader {
  font-weight: 600;
  font-size: 1.1vw;
  color: #343a40;
  /* color: blueviolet; */
}

.wvalue {
  font-weight: 600;
  color: #343a40;
  font-size: 1.9vw;
}

.listnone {
  list-style-type: none;
  padding: 0;
}

.marginright {
  margin-right: 13px;
}
</style>